<cc-box>
  <section content box class="inside-box-wrapper">
    <header class="header-wrapper">
      <div class="header-left">
        <div class="logo-wrapper">
          <img [src]="'assets/img/channels/logo-' + platformString + '.svg'"/>
        </div>
        <h6 translate class="title">INTEGRATIONS.{{integratedPlatformType}}.HEADER_TITLE</h6>
      </div>
      <button
        (click)="goBack()"
        mat-raised-button
        type="button"
        color="info-full"
        size="small"
        class="change-button">
        {{'BACK' | translate}}
      </button>
    </header>
    <main class="description-wrapper">
      <div class="image-part">
        <img [src]="'assets/img/channels/integration-installed-' + platformString + '.svg'" class="image-description"/>
      </div>
      <div class="text-part">
        <h6 translate class="description-title">INTEGRATIONS.{{integratedPlatformType}}.DESCRIPTION_TITLE</h6>
        <div [innerHTML]="'INTEGRATIONS.' + integratedPlatformType + '.DESCRIPTION_TEXT' | translate"></div>

        <div class="conditional-section-wrapper" *ngIf="!integrationInstalled && integrationProperties.isInstalledAutomatically">
          <a class="learn-more" translate href="{{integrationProperties.howToLink}}" target="_blank">INTEGRATIONS.HERE</a>
          <span [innerHTML]="', '"></span>
          <span translate>INTEGRATIONS.{{integratedPlatformType}}.LEARN_MORE</span>
        </div>

        <div class="conditional-section-wrapper" *ngIf="integrationInstalled">
          <h6 translate class="description-title">INTEGRATIONS.NOTE</h6>
          <div [innerHTML]="'INTEGRATIONS.' + integratedPlatformType + '.NOTE' | translate"></div>
        </div>

        <div class="conditional-section-wrapper" *ngIf="!integrationInstalled && integrationProperties.requiresSupportContact">
          <h6 translate class="description-title">INTEGRATIONS.HOW_TO</h6>
          <div [innerHTML]="'INTEGRATIONS.' + integratedPlatformType + '.HOW_TO_DESCRIPTION' | translate"></div>
        </div>

        <div *ngIf="integrationInstalled && integrationProperties.shouldDisplayAccountName"
             class="integrated-with-account">
          <span translate>INTEGRATIONS.{{integratedPlatformType}}.INTEGRATED_WITH_ACCOUNT</span>
          <span class="account-name">{{integrationPlatform?.accountName}}</span>
        </div>

        <div class="conditional-section-wrapper" *ngIf="integrationProperties.useApiKey">
          <div class="integration-input-wrapper">
            <span translate>INTEGRATIONS.API_TOKEN</span>
            <span>{{(apiKey$ | async).apiKey}}</span>
          </div>

          <div class="integration-input-wrapper">
            <span translate>INTEGRATIONS.ACCOUNT_NAME</span>
            <span>{{accountName}}</span>
          </div>
        </div>


      </div>

    </main>
    <div class="conditional-section-wrapper" *ngIf="integratedPlatformType === 'ZAPIER'">
      <cc-dynamic-zaps-initiation></cc-dynamic-zaps-initiation>
    </div>

    <div class="install-button" *ngIf="integrationInstalled">
      <div class="auto-resync-wrapper" *ngIf="integrationProperties.allowAutoResync">
        <span class="auto-resync-text" translate>INTEGRATIONS.AUTO_RESYNC</span>
        <ui-switch (change)="toggleAutoResync($event)" [checked]="integrationPlatform.resyncEnabled"></ui-switch>
      </div>

      <button
        (click)="uninstall()"
        *ngIf="uninstallEnabled"
        [disabled]="uninstallInProgress"
        mat-raised-button
        type="button"
        borderless
        color="warn">
        {{'INTEGRATIONS.UNINSTALL' | translate}}
      </button>
      <button
        *ngIf="integrationProperties.allowsImport"
        (click)="resync()"
        mat-raised-button
        [disabled]="uninstallInProgress || duringResync || ((latestImport$ | async)?.status === 'STARTED')"
        type="button"
        color="info-full">
        {{'INTEGRATIONS.RESYNC' | translate}}
      </button>
      <button
        *ngIf="integrationProperties.externalPanelUrl"
        (click)="openExternalPanel()"
        mat-raised-button
        type="button"
        color="primary-full">
        {{'INTEGRATIONS.' + integratedPlatformType + '.EXTERNAL_PANEL_URL' | translate}}
      </button>
    </div>

    <div class="install-button" *ngIf="!integrationInstalled">
      <button
        (click)="install()"
        mat-raised-button
        type="button"
        color="primary-full">
        {{'INTEGRATIONS.' + integratedPlatformType + '.INSTALL' | translate}}
      </button>
    </div>
  </section>
</cc-box>

